import { useEffect, useState, useRef } from 'react';
import { motion, useInView } from 'framer-motion';

export default function StatsCounter({ value, suffix = '', prefix = '', label, color = '#FFCD40' }) {
  const [count, setCount] = useState(0);
  const ref = useRef(null);
  const isInView = useInView(ref, { once: true, margin: "-50px" });
  const numericValue = parseFloat(String(value).replace(/[^0-9.]/g, ''));

  useEffect(() => {
    if (!isInView) return;
    const duration = 2000;
    const steps = 60;
    const increment = numericValue / steps;
    let current = 0;
    const timer = setInterval(() => {
      current += increment;
      if (current >= numericValue) {
        setCount(numericValue);
        clearInterval(timer);
      } else {
        setCount(current);
      }
    }, duration / steps);
    return () => clearInterval(timer);
  }, [isInView, numericValue]);

  const displayValue = Number.isInteger(numericValue) ? Math.round(count) : count.toFixed(1);

  return (
    <motion.div
      ref={ref}
      className="text-center"
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6 }}
    >
      <div className="font-anton text-3xl md:text-4xl lg:text-5xl" style={{ color }} data-testid={`stat-${label?.replace(/\s/g, '-').toLowerCase()}`}>
        {prefix}{displayValue}{suffix}
      </div>
      <div className="font-instrument text-xs md:text-sm tracking-wider uppercase mt-2" style={{ color: 'rgba(255,252,238,.5)' }}>
        {label}
      </div>
    </motion.div>
  );
}
